import { apiClient } from "./client";
import type {
  CostHistoryDto,
  CostSummaryDto,
  CostTrendDto,
  DashboardSummaryDto,
  DauTrendDto,
} from "./types";

/** §8.2 运营看板汇总 */
export function getDashboardSummary() {
  return apiClient.get<DashboardSummaryDto>("/dashboard/summary");
}

/** §8.2 成本趋势(依赖 Cost Explorer,可能 available=false)——现展示在独立的 Cost Summary 页面 */
export function getCostTrend(days = 30) {
  return apiClient.get<CostTrendDto>("/dashboard/cost-trend", { days });
}

/** §8.2 v2.10:每日活跃用户数趋势(Dashboard 页原"成本趋势"图表位置改用此接口) */
export function getDauTrend(days = 30) {
  return apiClient.get<DauTrendDto>("/dashboard/dau-trend", { days });
}

/** §8.2 v2.10:Cost Summary 新页面 —— 平台账号 + 每一个纳管账号的 Month-to-date 费用 */
export function getCostSummary() {
  return apiClient.get<CostSummaryDto>("/dashboard/cost-summary");
}

/** §8.2 v2.11:Cost Summary 历史每月费用合计(默认最近 12 个月) */
export function getCostHistory(months = 12) {
  return apiClient.get<CostHistoryDto>("/dashboard/cost-history", { months });
}
